import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  opakowanieResource,
  Opakowanie,
} from "@megarax/client/src/resources/plm";
import { getDefaultModuleComponents } from "@/components/nameResource/components";

export const opakowanieModule: ResourceAppModule = {
  ...getDefaultModuleComponents(opakowanieResource),
  route: "opakowanie",
  title: "Opakowania",
  app: plmApp,
  itemConstructor: Opakowanie,
  resource: opakowanieResource,
  iconClass: "fas fa-box-open fa-fw",
};
